import { render } from "./userGroups.vue?vue&type=template&id=2f0d8174"
import script from "./userGroups.vue?vue&type=script&lang=js"
export * from "./userGroups.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__